var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-group',{attrs:{"title":"Colors"}},[_c('nested-checkbox-group',{attrs:{"groups":_vm.colorFamilies,"selected-values":_vm.selectedFilters},on:{"change":_vm.emitUpdatedFilters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }